import { getAPI, postAPI } from "../..";
import config from "../../../utils/config";
import { GRAPH_URL, MICE_GRAPH_URL, VENDOR_MIS_UPLOAD_URL } from "../../url";

export const getMISGraphAPI = async (
  from_date = "",
  to_date = "",
  email = ""
) => {
  if (from_date === "") {
    from_date = "2020-01-01";
  }
  if (to_date === "") {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const day = currentDate.getDate().toString().padStart(2, "0");
    to_date = `${year}-${month}-${day}`;
  }

  let graphUrl =
    config.quicklinkUrl +
    GRAPH_URL +
    `?from_date=${from_date}&to_date=${to_date}`;
  if (email != "") {
    graphUrl =
      config.quicklinkUrl +
      GRAPH_URL +
      `?from_date=${from_date}&to_date=${to_date}` +
      "&current_user_email=" +
      email;
  }

  let response = await getAPI(graphUrl, false);
  return response;
};

export const getMISMICEGraphAPI = async (
  from_date = "",
  to_date = "",
  email = ""
) => {
  if (from_date === "") {
    from_date = "2020-01-01";
  }
  if (to_date === "") {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const day = currentDate.getDate().toString().padStart(2, "0");
    to_date = `${year}-${month}-${day}`;
  }

  let graphUrl =
    config.quicklinkUrl +
    MICE_GRAPH_URL +
    `?from_date=${from_date}&to_date=${to_date}`;
  if (email != "") {
    graphUrl =
      config.quicklinkUrl +
      MICE_GRAPH_URL +
      `?from_date=${from_date}&to_date=${to_date}` +
      "&current_user_email=" +
      email;
  }

  let response = await getAPI(graphUrl, false);
  return response;
};

export const uploadMISFileAPI = async (body, type) => {
  let response = await postAPI(
    config.quicklinkUrl + VENDOR_MIS_UPLOAD_URL + "?type=" + type,
    body
  );
  return response;
};
